import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import api from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const raw = localStorage.getItem("neev_user");
    return raw ? JSON.parse(raw) : null;
  });
  const [booting, setBooting] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("neev_token");
    if (!token) { setBooting(false); return; }
    api.get("/auth/me")
      .then((r) => { setUser(r.data); localStorage.setItem("neev_user", JSON.stringify(r.data)); })
      .catch(() => { localStorage.removeItem("neev_token"); localStorage.removeItem("neev_user"); setUser(null); })
      .finally(() => setBooting(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("neev_token", data.token);
    localStorage.setItem("neev_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("neev_token");
    localStorage.removeItem("neev_user");
    setUser(null);
  };

  const value = useMemo(
    () => ({ user, booting, login, logout, isAdmin: user?.role === "admin" }),
    [user, booting]
  );

  return (
    <AuthCtx.Provider value={value}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
